<template>
  <auth-guard
    :authorized="$store.getters.can('api.view_brokerageterm')"
    type="hidden"
  >
    <v-card>
      <v-card-subtitle v-if="!editingInfo">
        <v-row class="pl-4">
          Terms
          <base-button
            color="info"
            icon-bool
            x-small
            @clicked="editingInfo = true"
            v-if="$store.getters.can('api.change_yard')"
            icon="mdi-pencil"
          />
        </v-row>
      </v-card-subtitle>
      <div
        class="ml-4 mt-n4"
        v-if="Object.keys(brokerTerms).length !== 0 && !editingInfo"
      >
        <v-row>
          <card-list-item
            v-if="brokerTerms.minimum_volume_type === 'UNT'"
            title="Minimum Units Required"
            :breakpoint-col-val="6"
            :other-col-val="4"
          >
            {{ brokerTerms.minimum_volume_units }}
          </card-list-item>
          <card-list-item
            v-if="brokerTerms.minimum_volume_type === 'LBS'"
            title="Minimum Units Pounds"
            :breakpoint-col-val="6"
            :other-col-val="4"
          >
            {{ brokerTerms.minimum_volume_lbs }} lbs
          </card-list-item>
        </v-row>
        <v-row>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Pt Rate"
          >
            {{ brokerTerms.pt_rate | filterZero }}
          </card-list-item>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Pd Rate"
          >
            {{ brokerTerms.pd_rate | filterZero }}
          </card-list-item>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Rh Rate"
          >
            {{ brokerTerms.rh_rate | filterZero }}
          </card-list-item>
        </v-row>
        <v-row>
          <card-list-item
            title="Treatment Charge"
            :breakpoint-col-val="6"
            :other-col-val="4"
          >
            <fx-tag
              :fx="brokerTerms.treatment_charge_fx"
              :value="brokerTerms.treatment_charge"
              :cur="brokerTerms.fx_currency"
            />
          </card-list-item>
          <card-list-item
            title="Handling Fee"
            :breakpoint-col-val="6"
            :other-col-val="4"
          >
            <fx-tag
              :fx="brokerTerms.handling_fee_fx"
              :value="brokerTerms.handling_fee"
              :cur="brokerTerms.fx_currency"
            />
          </card-list-item>
          <card-list-item
            title="Finance Charge %"
            :breakpoint-col-val="6"
            :other-col-val="4"
          >
            {{ brokerTerms.finance_charge_percent }}
          </card-list-item>
          <card-list-item
            title="Payout Type"
            :breakpoint-col-val="6"
            :other-col-val="4"
          >
            {{ brokerTerms.ounce_payout_type_text }}
          </card-list-item>
          <card-list-item
            title="Cont. Deduction %"
            :breakpoint-col-val="6"
            :other-col-val="4"
          >
            {{ brokerTerms.contained_percent_deduction }}
          </card-list-item>
          <card-list-item
            title="Freight Responsibility"
            :breakpoint-col-val="6"
            :other-col-val="4"
          >
            {{ brokerTerms.freight_responsibility_text }}
          </card-list-item>
        </v-row>
        <v-row>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Pt Refining Charge"
          >
            <fx-tag
              :fx="brokerTerms.refining_charge_pt_fx"
              :value="brokerTerms.refining_charge_pt"
              :cur="brokerTerms.fx_currency"
            />
          </card-list-item>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Pd Refining Charge"
          >
            <fx-tag
              :fx="brokerTerms.refining_charge_pd_fx"
              :value="brokerTerms.refining_charge_pd"
              :cur="brokerTerms.fx_currency"
            />
          </card-list-item>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Rh Refining Charge"
          >
            <fx-tag
              :fx="brokerTerms.refining_charge_rh_fx"
              :value="brokerTerms.refining_charge_rh"
              :cur="brokerTerms.fx_currency"
            />
          </card-list-item>
        </v-row>
        <v-row>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Assay Charge"
          >
            <fx-tag
              :fx="brokerTerms.assay_charge_fx"
              :value="brokerTerms.assay_charge"
              :cur="brokerTerms.fx_currency"
            />
          </card-list-item>
        </v-row>
        <v-row>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Shredding Fee"
          >
            <fx-tag
              :fx="brokerTerms.shredding_fee_fx"
              :value="brokerTerms.shredding_fee"
              :cur="brokerTerms.fx_currency"
            />
          </card-list-item>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="12"
            :other-col-val="8"
            title="Brokerage Rate"
          >
            <span v-if="brokerTerms.brokerage_rate_mode === 'NA'">
              {{ brokerTerms.brokerage_rate_mode_text }}
            </span>
            <span v-else>
              {{ (brokerTerms.brokerage_rate * 100).toFixed(2) }}%
              of {{ brokerTerms.brokerage_rate_mode_text }}
            </span>
          </card-list-item>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Client Payment Days"
          >
            {{ brokerTerms.client_payment_days }}
          </card-list-item>
        </v-row>
        <v-row>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Interest Rate type"
          >
            {{ brokerTerms.interest_rate_type_text }}
          </card-list-item>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Point"
          >
            {{ brokerTerms.point }}
          </card-list-item>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Payment Day Basis"
          >
            {{ brokerTerms.payment_day_basis_text }}
          </card-list-item>
          <card-list-item
            breakpoint="mdAndDown"
            :breakpoint-col-val="6"
            :other-col-val="4"
            title="Hedge Ounces"
          >
            {{ brokerTerms.hedge_ounces_text }}
          </card-list-item>
        </v-row>
        <card-list-item
          no-cols
          title="Additional Terms"
        >
          {{ brokerTerms.additional_terms | filterNA }}
        </card-list-item>
        <card-list-item
          no-cols
          title="Description"
        >
          {{ brokerTerms.description | filterNA }}
        </card-list-item>
        <v-list-item v-if="brokerTerms">
          <v-list-item-content>
            <v-list-item-subtitle>
              Brokerage Files/Terms
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-card-actions
          v-if="brokerTerms"
          no-cols
        >
          <user-upload-list
            :baseurl="`/api/brokerage_terms/${brokerTerms.id}/`"
            :file-links="fileLinks"
          />
        </v-card-actions>
        <v-card-actions
          v-if="brokerTerms"
          no-cols
        >
          <user-upload-dialog
            :baseurl="`/api/brokerage_terms/${brokerTerms.id}/`"
            :file-links="fileLinks"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                small
                @click="on"
              >
                Attach Brokerage Files/Terms
              </v-btn>
            </template>
          </user-upload-dialog>
        </v-card-actions>
      </div>
      <card-list-item
        :other-col-val="12"
        v-else-if="!editingInfo"
        title="This yard does not have terms. Click pencil to add."
      />
      <write-broker-terms
        v-else
        :editing="true"
        :broker-terms="brokerTerms"
        @addTerms="addTerms"
        @updateTerms="updateTerms"
        @cancel="editingInfo = false"
      />
    </v-card>
  </auth-guard>
</template>

<script>
import WriteBrokerTerms from '../Write/WriteBrokerTerms'
import UserUploadDialog from '@/base/components/UserUploadDialog'
import fileLinks from '@/helpers/fileLinks'
import UserUploadList from '@/base/components/UserUploadList'

export default {
  name: 'BrokerTerms',
  props: {
    brokerTerms: {
      type: Object,
      required: false,
      default: null
    }
  },
  components: {
    UserUploadDialog,
    WriteBrokerTerms,
    UserUploadList
  },
  data: () => ({
    editingInfo: false
  }),
  computed: {
    fileLinks () {
      return fileLinks.brokerageTermsFileLinks(this.brokerTerms)
    }
  },
  methods: {
    addTerms (params) {
      this.editingInfo = false
      this.$emit('addTerms', params)
    },
    updateTerms (params) {
      this.editingInfo = false
      this.$emit('updateTerms', params)
    }
  }
}
</script>
